import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const PageFooterStyled = styled.div`
  display: flex;
  padding: 1.5rem 3rem;
  border-top: ${css.border};
  .left {
    margin-right: auto;
    ${css.flexVerticalCenter}
  }
  .center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    flex: 1;
    ${css.flexVerticalCenter}
  }
  .right {
    margin-left: auto;
    ${css.flexVerticalCenter}
    .btn {
      margin-left: 1rem;
    }
  }
`;

interface PageFooterProps {
  className?: string,
  left?: React.ReactNode,
  center?: React.ReactNode,
  right?: React.ReactNode,
}

/**
 * Page footer with optional left, center, and right slots.
 */
export const PageFooter = (props: PageFooterProps) => {
  return (
    <PageFooterStyled className={`page-footer${props.className ? ` ${props.className}` : ''}`}>
      {props.left && <div className="left">{props.left}</div>}
      {props.center && <div className="center">{props.center}</div>}
      {props.right && <div className="right">{props.right}</div>}
    </PageFooterStyled>
  );
};

const PageFooterCrumbsStyled = styled.div`
  ${css.flexVerticalCenter};
  .crumb-container {
    display: flex;
    justify-content: center;
    a {
      color: ${css.grey4};
      margin: 0 1rem;
      &.current {
        color: ${css.grey2};
      }
    }
  }
`;

interface PageFooterCrumbsProps {
  className?: string,
  children?: React.ReactNode,
}

/**
 * Footer breadcrumb container wrapping its children.
 */
export const PageFooterCrumbs = (props: PageFooterCrumbsProps) => {
  return (
    <PageFooterCrumbsStyled className={`page-footer-crumbs${props.className ? ` ${props.className}` : ''}`}>
      <div className="crumb-container">
        {props.children}
      </div>
    </PageFooterCrumbsStyled>
  );
};